import "../../styles/version-footer.css";
import packageInfo from "../../../../package.json";

// VIVA-1001 (CA-01): el badge publicaba la version exacta desplegada a cualquier
// visitante. Se apaga por omision y solo aparece si el ambiente lo pide. La version
// sigue disponible para el usuario en Ajustes, via VersionProduction.
const MOSTRAR_VERSION =
  (process.env.REACT_APP_MOSTRAR_VERSION || "").toLowerCase() === "true";

export const VersionFooter = () => {
  if (!MOSTRAR_VERSION) return null;

  const plataforma =
    process.env.REACT_APP_PLATAFORMA || process.env.REACT_PLATAFORMA || "Viva Nomada Red Social";
  const ambiente = process.env.REACT_APP_AMBIENTE || process.env.REACT_AMBIENTE || "";
  const label = [plataforma, ambiente, `V.${packageInfo.version}`]
    .map((value) => value.trim())
    .filter(Boolean)
    .join(" ");

  return (
    <div className="version-footer">
      <p>{label}</p>
    </div>
  );
};
